import { ConfigProvider, Spin } from 'antd';
import { Outlet } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import {
  getFeaturesFx,
  getIzParticipantsDictFx,
  getIzParticipantsFx,
  getLaborByActivityFx,
  getRegionCodesFx,
  getRegionsFx,
  getRoadsInRegionsFx,
  getSezParticipantsDictFx,
  getSezParticipantsFx,
  getVRPYearlyFx,
} from './models/investProModel/index.js';
import { CHTheme } from './theme/themeConfig.js';

function App() {
  const getFeaturesPeding = useUnit(getFeaturesFx.pending);
  const getRegionsPeding = useUnit(getRegionsFx.pending);
  const getIzParticipantsPeding = useUnit(getIzParticipantsFx.pending);
  const getSezParticipantsPeding = useUnit(getSezParticipantsFx.pending);
  const getLaborByActivityPeding = useUnit(getLaborByActivityFx.pending);
  const getRoadsInRegionsPeding = useUnit(getRoadsInRegionsFx.pending);
  const getVRPYearlyPeding = useUnit(getVRPYearlyFx.pending);
  const getRegionCodesPeding = useUnit(getRegionCodesFx.pending);
  const getIzParticipantsDictPeding = useUnit(getIzParticipantsDictFx.pending);
  const getSezParticipantsDictPeding = useUnit(
    getSezParticipantsDictFx.pending
  );

  const loading =
    getFeaturesPeding ||
    getRegionsPeding ||
    getIzParticipantsPeding ||
    getSezParticipantsPeding ||
    getLaborByActivityPeding ||
    getRoadsInRegionsPeding ||
    getVRPYearlyPeding ||
    getRegionCodesPeding ||
    getIzParticipantsDictPeding ||
    getSezParticipantsDictPeding;

  return (
    <ConfigProvider theme={CHTheme}>
      <Spin spinning={loading}>
        <Outlet />
      </Spin>
    </ConfigProvider>
  );
}

export default App;
